import React from 'react';

const TriangleIcon = ({ width = 10, height = 10, viewBox = '0 0 6 5', color = 'black', ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox={viewBox} fill="none" {...rest}>
    <path d="M3 5L0.401924 0.5L5.59808 0.5L3 5Z" fill={color} />
  </svg>
);

export default TriangleIcon;
